// API base URL is now env-driven (build-time). Set REACT_APP_API_URL per environment
// so the SAME source builds correctly everywhere — no source edits per deploy:
//   live  :  npm run build                       (uses .env.production = live URL)
//   staging: REACT_APP_API_URL=/ npm run build   (same-origin; nginx proxies /api -> :3006)
//   local :  REACT_APP_API_URL=http://localhost:3006/ npm start
// Fallback below keeps live as a safe default if the var is somehow unset.
const URL = process.env.REACT_APP_API_URL || 'https://api.climatemeet.me/';



const API = {
    logIn: URL + 'api/v1/admin/login',
    forgotPassword: URL + 'api/v1/admin/forgot-password',
    logOut: URL + "api/v1/admin/logout",
    getAdminProfile: URL + 'api/v1/admin/getAdmin/profile',
    getGraphDetails: URL + 'api/v1/admin',
    getTerms: URL + "api/v1/content/slug/admin?slug=terms",
    getSubstantAction: URL + "api/v1/content/slug/admin?slug=substantiated",
    updateTerms: URL + 'api/v1/content',
    getPrivacy: URL + 'api/v1/content/slug/admin?slug=privacy',
    updatePrivacy: URL + 'api/v1/content',
    getLegal: URL + 'api/v1/content/slug/admin?slug=legal',
    updateAdminProfile: URL + 'api/v1/admin',
    changePassword: URL + 'api/v1/admin/change-password',
    uploadPhoto: URL + 'api/v1/users/upload-profile-image',
    uploadGraphPhoto: URL + 'api/v1/graphs/upload',
    uploadNewsPhoto: URL + 'api/v1/news/news-photo',
    createEvent: URL + 'api/v1/events/',
    createSlot: URL + 'api/v1/slots/',
    createNews: URL + 'api/v1/news/',
    createFaq: URL + 'api/v1/faq/',
    createTag: URL + 'api/v1/tags/',
    updateTag: URL + 'api/v1/tags',
    addMoreSchedule: URL + 'api/v1/eventsDate/',
    getAllUsers: URL + 'api/v1/users',
    getAllSlots: URL + 'api/v1/slots',
    getAllEventAttend: URL + 'api/v1/eventAttendStatus',
    getEventAttendanceStats: URL + 'api/v1/eventAttendStatus/event',
    getAllFeedback: URL + 'api/v1/feedbacks',
    getAllNews: URL + 'api/v1/news/admin/new-list',
    getAllFaq: URL + 'api/v1/faq/list/admin',
    getAllTag: URL + 'api/v1/tags/',
    getAllCountries: URL + 'api/v1/users/country-states',
    getAllEvents: URL + 'api/v1/admin/events/list',
    getAllEventsDate: URL + 'api/v1/eventsDate',
    getAllSuggestions: URL + 'api/v1/suggestions',
    getUserProfile: URL + 'api/v1/users/get/profile',
    getNews: URL + 'api/v1/news',
    getFaq: URL + 'api/v1/faq',
    getFeedback: URL + 'api/v1/feedbacks',
    eventDetail: URL + 'api/v1/admin/events/detail',
    getEventsDateDetail: URL + 'api/v1/eventsDate',
    addFriends: URL + 'api/v1/admin/add/friends/list',
    updateUserProfile: URL + 'api/v1/users',
    updateGraphDetails: URL + 'api/v1/graphs',
    updateNews: URL + 'api/v1/news',
    updateFaq: URL + 'api/v1/faq',
    updateDistance: URL + 'api/v1/admin/update/distance',
    updateEvent: URL + 'api/v1/events',
    updateEventsDate: URL + 'api/v1/eventsDate',
    updateSlots: URL + 'api/v1/slots',
    blockUser: URL + 'api/v1/admin/update/status',
    removeUser: URL + 'api/v1/admin/delete/user',
    removeEvent: URL + 'api/v1/events',
    removeSuggestion: URL + 'api/v1/suggestions',
    removeNews: URL + 'api/v1/news',
    removeFaq: URL + 'api/v1/faq',
    removeTag: URL + 'api/v1/tags',
    removeFeedback: URL + 'api/v1/feedbacks',
    deleteSlot: URL + 'api/v1/slots',
    deleteDate: URL + 'api/v1/eventsDate',
    getAllRemovedUsers: URL + 'api/v1/admin/deleted/users',
    unFriend : URL + 'api/v1/admin/unfriend/user/friend/list',
    Groups : URL + 'api/v1/groups/admin',
    getAllFriendsAndGroups : URL + 'api/v1/admin/users/friends/list',
    getGroupDetail : URL + 'api/v1/groups/admin/group-detail',
    getSuggestionDetail : URL + 'api/v1/suggestions',
    getAllNetworks: URL + 'api/v1/networks/admin/list',
    getActiveNetworks: URL + 'api/v1/networks',
    getNetwork: URL + 'api/v1/networks',
    createNetwork: URL + 'api/v1/networks',
    updateNetwork: URL + 'api/v1/networks',
    removeNetwork: URL + 'api/v1/networks',
    getActiveRewardConfig: URL + 'api/v1/rewardConfig/admin/active',
    getRewardConfigHistory: URL + 'api/v1/rewardConfig/admin/history',
    getAllRewardConfigs: URL + 'api/v1/rewardConfig/admin/list',
    getRewardConfig: URL + 'api/v1/rewardConfig/admin',
    createRewardConfig: URL + 'api/v1/rewardConfig/admin',
    updateRewardConfig: URL + 'api/v1/rewardConfig/admin',
    removeRewardConfig: URL + 'api/v1/rewardConfig/admin',
    getAllMonthlyPayments: URL + 'api/v1/admin/monthly-payouts',
    getMonthlyPaymentDetail: URL + 'api/v1/admin/monthly-payouts/detail',
    approveMonthlyPayment: URL + 'api/v1/admin/monthly-payouts',
    confirmMonthlyPayment: URL + 'api/v1/admin/monthly-payouts',
    markAllMonthlyPaymentsAsPaid: URL + 'api/v1/admin/monthly-payouts',
    exportMonthlyPaymentsExcel: URL + 'api/v1/admin/monthly-payouts',
    getSlotRewards: URL + 'api/v1/admin/slots',
    getRewardAnalysis: URL + 'api/v1/admin/reward-analysis',
    // User-facing reward endpoints
    getUserWallet: URL + 'api/v1/users/wallet',
    updateUserWalletAddress: URL + 'api/v1/users/wallet-address',
    getUserMonthlyRecap: URL + 'api/v1/users/monthly-recap',
    getPassedEventsWithEarnings: URL + 'api/v1/bookmarkEvents'
}

export default API;

export { URL }